module.exports = __webpack_public_path__ + "img/incident_proteccion_civil.02127515.svg";